/**
 * Was der Server gesagt hat, in einem Satz (#1245).
 *
 * `ApiError.message` ist aus Gründen der Rückwärtskompatibilität immer „Network response was not
 * ok". Das half beim Suchen eines echten Fehlers keinen Schritt weiter: der Server hatte
 * „None is not of type 'object' — 'sections.0.condition'" geantwortet, und die Oberfläche zeigte
 * eine Meldung, die nichts sagte. Status und Antwort liegen am Fehler bereit — sie gehören in die
 * Meldung.
 */
export const apiErrorText = (error: unknown): string => {
  const status = (error as { status?: number })?.status;
  const body = (error as { body?: unknown })?.body;

  const ausBody = ((): string | null => {
    if (typeof body === 'string' && body.trim()) {
      return body.trim();
    }
    if (body && typeof body === 'object') {
      const daten = body as Record<string, unknown>;
      for (const schluessel of ['detail', 'message', 'title', 'error']) {
        const wert = daten[schluessel];
        if (typeof wert === 'string' && wert.trim()) {
          return wert.trim();
        }
        // Der Server schickt bei fachlichen Konflikten ein Objekt: `{detail: {message, issues}}`.
        const verschachtelt = (wert as { message?: unknown } | null)?.message;
        if (typeof verschachtelt === 'string' && verschachtelt.trim()) {
          return verschachtelt.trim();
        }
      }
    }
    return null;
  })();

  if (status === 401 || status === 403) {
    return 'Die Anmeldung ist abgelaufen oder die Berechtigung fehlt.';
  }
  // Die Meldung des Servers hat Vorrang. Früher wurde jede 409 zu »zwischenzeitlich geändert,
  // bitte neu laden« — auch »Der Entscheidungsbaum hat noch Fehler« beim Veröffentlichen und die
  // Ablehnung eines Baums beim Urkundenstart. Neu laden half in keinem der beiden Fälle
  // (#1245, Teil 38).
  if (ausBody) {
    return status ? `${ausBody} (${status})` : ausBody;
  }
  if (status === 409) {
    return 'Der Stand hat sich zwischenzeitlich geändert. Bitte die Seite neu laden.';
  }
  if (status) {
    return `Der Server hat mit ${status} geantwortet.`;
  }
  return error instanceof Error ? error.message : 'Unbekannter Fehler.';
};
